import { render, staticRenderFns } from "./form-manager.vue?vue&type=template&id=4736f909&scoped=true"
import script from "./form-manager.vue?vue&type=script&lang=js"
export * from "./form-manager.vue?vue&type=script&lang=js"
import style0 from "./form-manager.vue?vue&type=style&index=0&id=4736f909&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4736f909",
  null
  
)

export default component.exports